import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const UsersIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props} fill={color} >
    <path
      d="M13.8366 9.20668C14.34 8.34918 14.5633 7.35001 14.4625 6.34001C14.3133 4.85335 13.4833 3.53918 12.1266 2.64001L11.2058 4.02835C12.1383 4.64668 12.7058 5.52751 12.8041 6.50668C12.8958 7.42751 12.5708 8.33501 11.9108 8.99501L10.9175 9.98835L12.2658 10.3842C15.7925 11.4175 15.8333 14.9642 15.8333 15H17.5C17.5 13.5092 16.7033 10.5958 13.8366 9.20668Z"
      fill={color}
    />
    <path
      d="M7.9165 10C9.75484 10 11.2498 8.50504 11.2498 6.66671C11.2498 4.82837 9.75484 3.33337 7.9165 3.33337C6.07817 3.33337 4.58317 4.82837 4.58317 6.66671C4.58317 8.50504 6.07817 10 7.9165 10ZM7.9165 5.00004C8.83567 5.00004 9.58317 5.74754 9.58317 6.66671C9.58317 7.58587 8.83567 8.33337 7.9165 8.33337C6.99734 8.33337 6.24984 7.58587 6.24984 6.66671C6.24984 5.74754 6.99734 5.00004 7.9165 5.00004ZM9.1665 10.8334H6.6665C3.909 10.8334 1.6665 13.0759 1.6665 15.8334V16.6667H3.33317V15.8334C3.33317 13.995 4.82817 12.5 6.6665 12.5H9.1665C11.0048 12.5 12.4998 13.995 12.4998 15.8334V16.6667H14.1665V15.8334C14.1665 13.0759 11.924 10.8334 9.1665 10.8334Z"
      fill={color}
    />
  </svg>
);

UsersIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

UsersIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(20, 20),
  ...helpers.getViewBoxProperty({ width: 20, height: 20 }),
};

export default UsersIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/users.js